module.exports = __webpack_public_path__ + "f2c787f6bddf1cfa20fdf7c2f92113cf.png";